import { formatDistanceToNowStrict } from 'date-fns';
import { get, startCase } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { REVIEW_TYPES } from '@upsolve/shared';
import { HR } from '@upsolve/ui';

import ModalBackground from '../overlays/ModalBackground';
import ImageInContext from '../Media/ImageInContext';
import viewReviewUrl from './viewReviewUrl';
import FacebookRecommendationIcon from '../../../static/images/icons/facebook-recommends.png';

const ReviewViewerModal = ({ review, onClose }) => {
  return (
    <ModalBackground onClick={() => onClose()}>
      <StyledReviewViewer onClick={(ev) => ev.stopPropagation()}>
        <div className={`reviewer-picture ${review.type === REVIEW_TYPES.FACEBOOK ? 'blur' : ''}`}>
          {review.type === REVIEW_TYPES.GOOGLE && <ImageInContext alt={review.reviewer.displayName} src={review.reviewer.profilePhotoUrl} />}
          {review.type === REVIEW_TYPES.FACEBOOK && <ImageInContext alt="Facebook User" fluid={get(review, 'reviewer.placeholderImage.image.image.fluid')} />}
        </div>
        <span className="reviewer-name">{startCase(review.reviewer.displayName || 'Private Facebook User')}</span>
        <div className="review__rating">
          {review.type === REVIEW_TYPES.GOOGLE && <><span className="stars">{Array(review.rating).fill('★', 0, review.rating).join('')}</span> {formatDistanceToNowStrict(new Date(review.createdAt))} ago</>}
          {review.type === REVIEW_TYPES.FACEBOOK && <><img src={FacebookRecommendationIcon} /> Recommended {formatDistanceToNowStrict(new Date(review.createdAt))} ago</>}
        </div>
        <div className="review__text">
          "{review.reviewText}"
        </div>
        <div className="review__actions">
          <HR />
          <span className="link-to-reviews" onClick={() => onClose()}>Close Review</span>
          <span className="link-to-reviews" onClick={() => viewReviewUrl(review.type)}>
            Read more {review.type === REVIEW_TYPES.GOOGLE ? 'Google' : 'Facebook'} reviews ⇾
          </span>
        </div>
      </StyledReviewViewer>
    </ModalBackground>
  );
}

const StyledReviewViewer = styled.div`
  width: 100%;
  padding: 2em;
  background: white;
  border-radius: 8px;
  color: ${props => props.theme.colors.gray[900]};
  display: flex;
  flex-direction: column;
  align-items: center;
  .reviewer-picture {
    height: 96px;
    min-height: 96px;
    width: 96px;
    min-width: 96px;
    border-radius: 48px;
    overflow: hidden;
    img {
      height: 100%;
      width: auto;
    }
    &.blur {
      & > div {
        min-height: 100%;
      }
      img {
        filter: blur(3px);
      }
    }
  }
  .reviewer-name {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    color: ${props => props.theme.colors.gray[500]};
    margin: 1em 0 0;
  }
  .review__rating {
    margin: 0.5em 0 0.25em;
    .stars {
      color: ${props => props.theme.colors.orange[500]};
      margin-right: 4px;
    }
  }
  .review__text {
    text-align: center;
    margin: 1em 0;
  }
  .review__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    hr {
      width: 100%;
      margin: 0.75em 0;
    }
    .link-to-reviews {
      color: ${props => props.theme.colors.brand[500]};
      cursor: pointer;
      text-align: center;
      margin-bottom: 0.75em;
    }
  }
`;

export default ReviewViewerModal;
